$(document).ready(function () {
    showProducts();
});

function showProducts() {
    if ($('.checkout-first-step .woocommerce-checkout-review-order-table')) {
        $('body').on('click', '.products-wrapper .heading', function () {
            var container = $('.checkout-first-step .woocommerce-checkout-review-order-table .products-wrapper');

            if (container.hasClass('active')) {
                container.removeClass('active');
                container.find('.all-products').slideUp();
            } else {
                container.addClass('active');
                container.find('.all-products').slideDown();
            }
        });
    }
}